import api from './api';

export interface GradingScaleItem {
  grade: string;
  min_score: number;
  max_score: number;
  description?: string;
}

export interface SchoolSettings {
  name: string;
  logo_url?: string;
  settings: {
    passing_mark?: number;
    grading_scale?: GradingScaleItem[];
  };
}

export const settingsService = {
  getSchoolSettings: async (): Promise<SchoolSettings | null> => {
    const response = await api.get('/settings/school');
    return response.data.success ? response.data.data : null;
  },

  updateSchoolSettings: async (data: SchoolSettings): Promise<void> => {
    const response = await api.post('/settings/school', data);
    return response.data.success;
  }
};
